/**
 * Subscription state.
 */
import { make } from "vuex-pathify";
import api from "@/api";

const endPoint = api.props.endPoints.subscription;

const state = {
  subscription: [],
  errorsOccurred: false
};

// automatically generate getters
const getters = make.getters(state);

const mutations = {
  ...make.mutations(state),
  // override
  setSubscription(state, subscription) {
    state.subscription = subscription;
  },
  setErrorsOccurred(state, value) {
    state.errorsOccurred = value;
  },
  cleanSubscription(state, cleanSubscription) {
    state.subscription = Object.assign(state.subscription, cleanSubscription);
  }
};

const actions = {
  ...make.actions(state),

  loadSubscription({ commit }, id) {
    commit("setErrorsOccurred", false);
    return new Promise(function(resolve) {
      api
        .getEntity(endPoint, id)
        .then(subscription => {
          commit("setSubscription", subscription);
          resolve(subscription);
        })
        .catch(ex => {
          commit("setErrorsOccurred", true);
          commit(
            "pushError",
            ex.msg || ex.value || "Failed to load API Subscription.",
            {
              root: true
            }
          );
        });
    });
  },
  updateSubscription({ commit }, dirtySubscription) {
    commit("setErrorsOccurred", false);
    return new Promise(function(resolve) {
      api
        .setEntity(endPoint, dirtySubscription)
        .then(() => {
          commit("cleanSubscription", dirtySubscription);
          resolve();
        })
        .catch(ex => {
          commit("setErrorsOccurred", true);
          commit("rollbackSubscription");
          commit(
            "pushError",
            ex.msg ||
              `Failed to update API Subscription "${dirtySubscription.name}".`,
            {
              root: true
            }
          );
        });
    });
  },
  deleteSubscription({ commit }) {
    commit("setErrorsOccurred", false);
    return new Promise(function(resolve) {
      api
        .delete(endPoint, state.subscription.id)
        .then(() => {
          resolve();
        })
        .catch(function(ex) {
          commit("setErrorsOccurred", true);
          commit(
            "pushError",
            ex.msg || ex.value || "Failed to delete API Subscription.",
            {
              root: true
            }
          );
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
